// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import pendingUnenrollItemView  from '../../../../templates/CCM/PendingUnenroll/pendingUnenrollItemView';

// Internal Dependencies - models/collections

export default Marionette.ItemView.extend({

	tagName: 'tr',

	events: {
		'click #confirmReject': 'confirm',
		'click #cancelReject': 'cancel'
	},

	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.model.set('isApcm', this.app.controller.isApcm);
	},

	getTemplate: function() {
		return pendingUnenrollItemView( this.model );
	},

	confirm: function( e ) {
		this.model.confirmUnenroll();
	},

	cancel: function() {
		this.model.cancelUnenroll();
	}

});
